import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { PasswordPolicy } from '@pages/reset-password/models/password-policy.interface';
import { ResetPasswordCodeResponse } from '@pages/reset-password/models/reset-password-code-response.interface';
import { ResetUserPasswordRequest } from '@pages/reset-password/models/reset-user-password-request.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordService {
  private readonly httpClient = inject(HttpClient);

  validateCode(passwordCodeKey: string): Observable<PasswordPolicy> {
    const url = `api/v1/organization/password-policy/${passwordCodeKey}`;

    return this.httpClient.get<PasswordPolicy>(environment.portalApiUrl + url);
  }

  resetPassword(request: ResetUserPasswordRequest): Observable<ResetPasswordCodeResponse> {
    const url = 'api/v3/user/password/reset';

    return this.httpClient.post<ResetPasswordCodeResponse>(environment.portalApiUrl + url, request);
  }
}
